export default "__VITE_ASSET__CjItCu3m__"